import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditProjectForm from './EditProjectForm'
import EditProjectModalHeader from './EditProjectModalHeader'
import ProjectLoader from './_load/ProjectLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const EditProjectModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <ProjectLoader>
        <EditProjectModalHeader />
        <Separator weight={4} />

        <EditProjectForm />
      </ProjectLoader>
    </ControlledModal>
  )
}

export default EditProjectModal
